var map = {
	"./drinking.svg": 434,
	"./exercise.svg": 435,
	"./lsc_top2.svg": 436,
	"./meal.svg": 437,
	"./obesity.svg": 438,
	"./rest.svg": 439,
	"./smoking.svg": 440
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 433;


//////////////////
// WEBPACK FOOTER
// ./src/images/lsc ^\.\/.*\.svg$
// module id = 433
// module chunks = 0